module.exports = __webpack_public_path__ + "img/chambre.1aefa3f2.jpg";